import React from 'react';
import { Button } from './ui/button';
import { heroData } from '../data/corporateData';
import { ArrowRight, Download } from 'lucide-react';

const CorporateHero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-[#0A192F]">
      {/* Background Image with Gradient Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src={heroData.heroImage}
          alt="Vijay Kadechkarr with Ranveer Singh"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A192F]/95 via-[#0A192F]/90 to-[#0A192F]/70"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-[#0A192F]"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 sm:px-8 lg:px-16 py-24 md:py-32">
        <div className="max-w-4xl">
          {/* Role Label */}
          <div className="mb-6" data-testid="hero-role-label">
            <span className="text-xs font-bold tracking-[0.2em] uppercase text-rose-500 font-heading">
              Executive Leadership
            </span>
          </div>

          {/* Main Tagline */}
          <h1 
            className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-white mb-6 font-heading leading-tight"
            data-testid="hero-tagline"
          >
            {heroData.tagline}
          </h1>

          {/* Stats Bar */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6 mb-10" data-testid="hero-stats">
            {heroData.stats.map((stat) => (
              <div 
                key={stat.id}
                className="bg-[#112240]/80 backdrop-blur-sm border border-white/10 rounded-lg p-6 hover:border-rose-500/50 transition-all duration-300"
                data-testid={`hero-stat-${stat.id}`}
              >
                <div className="text-3xl sm:text-4xl font-bold text-white mb-1 font-heading">
                  {stat.value}
                </div>
                <div className="text-sm text-slate-300 font-body uppercase tracking-wider">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <Button
              onClick={scrollToContact}
              className="bg-rose-600 text-white hover:bg-rose-500 text-base px-8 py-6 transition-all duration-300 hover:scale-105 font-semibold font-body shadow-lg shadow-rose-500/25"
              data-testid="hero-cta-explore"
            >
              Explore Strategic Profile <ArrowRight className="ml-2" size={18} />
            </Button>
            <Button
              onClick={scrollToContact}
              variant="outline"
              className="border-2 border-white/20 text-white hover:bg-white/10 hover:border-white/40 text-base px-8 py-6 transition-all duration-300 font-semibold font-body backdrop-blur-sm"
              data-testid="hero-cta-inquire"
            >
              Executive Inquiry
            </Button>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 hidden md:block">
        <div className="w-6 h-10 border-2 border-rose-500 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-rose-500 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
};

export default CorporateHero;
